export const trajectenMixin = {
  props: {
    step: {
      type: Object,
      default: () => {}
    },
    units: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      voortraject: [
        "Advies",
        "Aanvraag versturen",
        "Inschrijvingen deadline",
        "Opdrachtgunning"
      ], // standaard

      // naam van stap is type
      wizards: ["Uitvoering", "Facturatie", "NulInspectie"],

      // dit zijn de standaard taken bij uitvoering
      uitvoeringtaken: [
        "Bewonersbrief",
        "Voortgangsinspectie",
        "Noodvoorziening",
        "Oplevering",
        "Rapport"
      ],

      overig: [],
      hinder: [
        {
          label: "Lift tijdens kantooruren minder dan 2 uur buiten dienst",
          operationeel: true,
          kleur: "#00FF00"
        },
        {
          label:
            "lift tijdens kantooruren tussen 08:00 - 12:00 uur buiten dienst",
          operationeel: true,
          kleur: "#00ccff"
        },
        {
          label:
            "lift tijdens kantooruren tussen 12:30 - 16:30 uur buiten dienst",
          operationeel: true,
          kleur: "#0000ff"
        },
        {
          label:
            "lift tijdens kantooruren tussen 08:00 - 16:30 uur geheel buiten dienst",
          operationeel: false,
          kleur: "#ff6600"
        },
        {
          label:
            "lift gehele dag en gehele nacht buiten dienst, m.u.v. weekend",
          operationeel: false,
          kleur: "#ff0000"
        },
        {
          label: "lift gehele dag en gehele nacht buiten dienst incl. weekend",
          operationeel: false,
          kleur: "#ff0000"
        }
      ],
      DLA_auditors: [
        { Id: 21, Naam: "Roel Donken" },
        { Id: 184, Naam: "Nick Bal" },
        { Id: 28, Naam: "Inge Donken" },
        { Id: 710, Naam: "Berry Simon"},
        { Id: 792, Naam: "Johan Meijvogel"},
        { Id: 23, Naam: "Nordin Slimati" }
      ],
      DLA_personen: [
        { Id: 184, Naam: "Nick Bal" },
        { Id: 217, Naam: "Ed Huising" },
        { Id: 380, Naam: "Eric Kok" },
        { Id: 592, Naam: "Martijn Bouhuys" },
        { Id: 710, Naam: "Berry Simon"},
        { Id: 792, Naam: "Johan Meijvogel"},
        { Id: 28, Naam: "Inge Donken" },
        { Id: 21, Naam: "Roel Donken" },
        { Id: 73, Naam: "Fred Pelder" },
        { Id: 23, Naam: "Nordin Slimati" }
      ],
      CTC_personen: [
        { Id: 22, Naam: "Hans de Cocq" },
        { Id: 23, Naam: "Nordin Slimati" }
      ],
    };
  },
  computed: {
    personen: function() {
      return this[`${this.groep}_personen`];
    },
    CTC_auditors: function() { return [...this.CTC_personen] },
    groep: function () {
      return this.$store.getters.user ? this.$store.getters.user.advies : 'DLA';
    },
    auditors: function () {
      return this[`${this.groep}_auditors`];
    },
  }
};
